import styled from 'styled-components';
import { Card } from 'antd';
import { IThemeSelectorProps } from 'components/ThemeSelector/ThemeSelector';
import { Handle } from 'reactflow';
import { Link } from 'react-router-dom';

interface StyledCardProps {
  token: any;
  minHeight?: string;
}

export const StyledLinkButton = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  transition: transform 0.25s ease;
`;

export const StyledCard = styled(Card)<StyledCardProps, IThemeSelectorProps>`
  border: none;
  border-radius: 4px;
  overflow: hidden;
  background: linear-gradient(
    307deg,
    ${({ token }) => token.colorBgSpotlight} 84%,
    ${({ token }) => token.actionButtons} 95%
  );
  z-index: 2;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.3s ease;
  height: 100%;
  box-shadow: 0 0px 3px 2px ${({ token }) => token.colorBgSpotlight};

  &:hover {
    box-shadow: 0 0px 3px 9px ${({ token }) => token.colorBgSpotlight};
  }
  .ant-card-body {
    padding: 37px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  span {
    font-size: 16px;
    font-weight: 700;
    margin-top: 0;
    color: white;
    text-align: center;
    padding-bottom: 10px;

    @media (max-width: 1400px) {
      font-size: 16px;
    }
  }
`;

export const IconWrapper = styled.div<{ token: any }>`
  background: linear-gradient(
    135deg,
    ${({ token }) => token.colorPrimary},
    #2563eb
  );
  border-radius: 50%;
  padding: 12px;
  margin-bottom: 13px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
    color: #ffffff;
  }
`;

export const StyledMeta = styled(Card.Meta)<{ token: any }>`
  .ant-card-meta-title {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 8px;
    text-align: center;
    white-space: pre-line !important;
    text-transform: capitalize;

    @media (max-width: 1400px) {
      font-size: 14px;
    }
  }

  .ant-card-meta-description {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    text-align: center;
    line-height: 1.5;
  }
`;

export const CardNodeDiv = styled('div')`
  width: 220px;
  height: 100px;
  position: relative;
`;

export const HandleCard = styled(Handle)`
  top: 50%;
  opacity: 0;
`;
